module.exports = __webpack_public_path__ + "img/kx5200-char-2.d2e590a2.png";